import { Paragraphs } from "../types/project";

export const calcParagraphsLength = (paragraphs: Paragraphs[]): number[] =>
  paragraphs.map((paragraph) => paragraph.data.reduce((acc, data) => (acc += data.text.length), 0));
